import { API_URL } from '../../../../utils/config';

export const GET_EXPIRED_CUSTOMERS_MONTHLY_URL = `${API_URL}/getListOfExpiredCustomers`;
export const GET_CUSTOMER_USAGE_URL = `${API_URL}/geniatech/searchUsageByDate`;
export const SEARCH_FOR_EXPIRED_CUSTOMERS_BY_DAYS_URL = `https://legacy.tizeti.com/geniatechapi/index.php`;
// export const SEARCH_FOR_ABOUT_TO_EXPIRE_CUSTOMERS_BY_DAYS_URL = `${API_URL}/getListOfExpiredCustomers`;

export const SEARCH_FOR_ABOUT_TO_EXPIRE_CUSTOMERS_BY_DAYS_URL = `${API_URL}/users/countryexpiration`;
